export const CLUB_PAGE_VISITED = "eqxClubPageVisited";
export const CORP_JOIN_FLOW_DATA = "eqxCorpJoinFlowData";
export const CORP_JOIN_FLOW_PLANS = "eqxCorpJoinFlowPlans";
export const SINGLE_FLOW_FORM_STATE = "eqxSingleFlowFormState";
